// Plugin manifest. See ARCHITECTURE.md §15.

import { z } from "zod";

export interface PluginManifest {
  id: string;
  name: string;
  version: string;
  kind: ("adapter" | "widget" | "renderer" | "presentation-pack")[];
  entry: string;
  permissions: ("network" | "storage" | "clipboard" | "fs-readonly")[];
  capabilities?: Record<string, unknown>;
  signature?: string;
  publisher?: string;
}

export const zPluginManifest: z.ZodType<PluginManifest> = z.object({
  id: z.string().regex(/^[a-z][a-z0-9-]*\.[a-z][a-z0-9-]*$/),
  name: z.string().min(1),
  version: z.string().regex(/^\d+\.\d+\.\d+(-[\w.]+)?$/),
  kind: z.array(z.enum(["adapter", "widget", "renderer", "presentation-pack"])).min(1),
  entry: z.string(),
  permissions: z.array(z.enum(["network", "storage", "clipboard", "fs-readonly"])),
  capabilities: z.record(z.unknown()).optional(),
  signature: z.string().optional(),
  publisher: z.string().optional(),
});
